import { Action } from '@ngrx/store';

export class TraderAdvisorAction implements Action {

    public static getAccuracy = '[Trader Advisor] get_accuracy';
    public static getAccuracyError = '[Trader Advisor] get_accuracy_error';
    public static getAccuracySuccess = '[Trader Advisor] get_accuracy_success';

    public static getAppt = '[Trader Advisor] get_appt';
    public static getApptError = '[Trader Advisor] get_appt_error';
    public static getApptSuccess = '[Trader Advisor] get_appt_success';

    public static getDailydiscipline = '[Trader Advisor] get_dailydiscipline';
    public static getDailydisciplineError = '[Trader Advisor] get_dailydiscipline_error';
    public static getDailydisciplineSuccess = '[Trader Advisor] get_dailydiscipline_success';

    public static getLossesGreaterThanAverage = '[Trader Advisor] get_lossesGreaterThanAverage';
    public static getLossesGreaterThanAverageError = '[Trader Advisor] get_lossesGreaterThanAverage_error';
    public static getLossesGreaterThanAverageSuccess = '[Trader Advisor] get_lossesGreaterThanAverage_success';
    
    public static getWhatsappStatus = '[Trader Advisor] get_whatsappStatus';
    public static getWhatsappStatusError = '[Trader Advisor] get_whatsappStatus_error';
    public static getWhatsappStatusSuccess = '[Trader Advisor] get_whatsappStatus_success';

    public static setWhatsappStatus = '[Trader Advisor] set_whatsappStatus';
    public static setWhatsappStatusError = '[Trader Advisor] set_whatsappStatus_error';
    public static setWhatsappStatusSuccess = '[Trader Advisor] set_whatsappStatus_success';
    
    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
